import { ApiModel } from './models/api.model';

export const API: ApiModel = {
  domains: {
    aus: 'https://my.workshopsoftware.com.au',
    can: 'https://my.workshopsoftware.com',
    gbr: 'https://my.workshopsoftwareuk.com',
    usa: 'https://my.workshopsoftware.com'
  },
  subdomain: 'my',
  url      : SERVER_ENDPOINT || '/api'
};
